<template>
  <base-link
    class="LineLink"
    v-bind="$attrs"
    :class="classes"
  >
    <span :class="['LineLink__text', { 't-align-fix': size !== 'inherit' }]">
      <slot />
    </span>
  </base-link>
</template>

<script>
export default {
  name: "LineLink",

  props: {
    size: {
      type: String,
      default: 'regular',
      validator: (value) => {
        return [
          'regular',
          'small',
          'xx-small',
          'inherit'
        ].includes(value)
      }
    },
    invert: { type: Boolean, default: false }
  },

  computed: {
    classes () {
      return [
        {
          regular: 't-h4 font-light',
          small: 't-h5 font-normal',
          'xx-small': 'LineLink--text-xxs',
          inherit: 'LineLink--inherit'
        }[this.size],
        {
          'LineLink--inverted': this.invert
        }]
    }
  }
}
</script>

<style lang="postcss">
.LineLink {
  @apply relative
    inline-block
    px-xxxs
    text-off-black
    -mx-xxxs
    font-medium;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
  margin-top: -0.25em;
  margin-bottom: -0.25em;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 1px;
    width: calc(100% - (theme('spacing.xxxs') * 2));
    display: block;
    background-color: theme('colors.off-black');
  }

  &:hover {
    color: theme('colors.off-black');
  }

  &:focus {
    outline: unset;
  }

  .is-dark-chrome-theme &,
  &--inverted {
    color: theme('colors.white');

    &::after {
      background-color: theme('colors.white');
    }

    &:hover {
      color: theme('colors.white');
    }
  }

  &--inherit {
    padding-bottom: inherit;
  }

  em {
    @apply not-italic;
  }

  strong, b {
    @apply font-normal;
  }

  &--text-xxs {
    @apply text-xxs;
  }
}
</style>
